<template>
  <div>
    <h1 class="title_welcome">{{ $t('welcome_popup.achievements.achievement_title', { prize: getCurrentPrize }) }}</h1>
    <p class="from_to_data_welcome" style="text-align: center">
      {{ getAchievementStartData }} — {{ getAchievementFinishData }}
    </p>
    <h2 class="price_fond_welcome">
      {{
        $t('welcome_popup.achievements.prize_fund', {
          gameName: getNameGameAchievement,
          amountSpins: getAmountSpins,
          prize: getCurrentPrize
        })
      }}
    </h2>
    <ul class="info_list_welcome">
      <li class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.text_1', {
            currencyCode: getFormatedCurrency,
            minBet: getAchievementMinBet,
            prize: getCurrentPrize
          })
        }}
      </li>
      <li v-if="hasRoundsCondition" class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.text_receive_1', {
            totalRounds: getAchievementTotalRounds,
            gamesList: getAchievementGameNamesList,
            prize: getCurrentPrize
          })
        }}
      </li>
      <li v-if="hasBetsCondition" class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.text_receive_2', {
            totalBets: getAchievementTotalBets,
            currencyCode: getFormatedCurrency,
            gamesList: getAchievementGameNamesList,
            prize: getCurrentPrize
          })
        }}
      </li>
      <li v-if="hasWinsCondition" class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.text_receive_3', {
            totalWins: getAchievementTotalWins,
            currencyCode: getFormatedCurrency,
            gamesList: getAchievementGameNamesList,
            prize: getCurrentPrize
          })
        }}
      </li>
      <li class="info_item_welcome">
        {{ $t('welcome_popup.achievements.text_receive_4') }}
      </li>
      <li v-if="!isAchievementPrizeGame" class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.text_2', {
            gameName: getNameGameAchievement
          })
        }}
      </li>
      <li v-if="isAchievementPrizeGame" class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.text_2_prize_game', {
            gameName: getNameGameAchievement,
            prize: getCurrentPrize
          })
        }}
      </li>
      <li v-if="isAchievementCounter" class="info_item_welcome">
        {{ $t('welcome_popup.achievements.receive_free_spins', { amountFreeSpins: totalFreeSpinsAchievementCounter }) }}
      </li>
      <li v-if="isAchievementCounter" class="info_item_welcome">
        {{
          $t('welcome_popup.achievements.receive_participants', {
            amountParticipants: totalParticipantsAchievementCounter
          })
        }}
      </li>
      <li v-if="isAchievementCounter" class="info_item_welcome">
        {{ $t('welcome_popup.achievements.free_spins_for_one', { freeSpinsForOne: getAmountSpins }) }}
      </li>
    </ul>
    <LogoTransition />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import LogoTransition from '@/components/otherComponents/LogoTransition.vue';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'AchievementsWelcomeContent',
  components: {
    LogoTransition
  },
  computed: {
    ...mapGetters([
      'getAchievementStartData',
      'getAchievementFinishData',
      'getNameGameAchievement',
      'getReward',
      'getAchievementCurrency',
      'getAchievementMinBet',
      'getAchievementTotalRounds',
      'getAchievementTotalBets',
      'getAchievementTotalWins',
      'hasRoundsCondition',
      'hasBetsCondition',
      'hasWinsCondition',
      'isAchievementCounter',
      'getAchievementGameNamesList',
      'totalFreeSpinsAchievementCounter',
      'totalParticipantsAchievementCounter',
      'isAchievementBG',
      'isAchievementFS',
      'isAchievementPrizeGame',
      'isNeedMoneyOnBalance'
    ]),
    getFormatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.getAchievementCurrency);
    },
    getCurrentPrize(): string {
      return this.isAchievementPrizeGame ? this.getPrizeGame : <string>this.$i18n.t('free_spins_popups.free_spins');
    },
    getAmountSpins(): string {
      return this.isAchievementPrizeGame ? '' : this.getReward.rounds;
    },
    getPrizeGame(): string {
      switch (true) {
        case this.isAchievementBG:
          return <string>this.$i18n.t('free_spins_popups.bonus_game');
        case this.isAchievementFS:
          return <string>this.$i18n.t('free_spins_popups.free_spins_game');
        default:
          return '';
      }
    }
  }
});
</script>
